<custom-window title='Servers'>
    <div class="dialog-container">
        <mat-dialog-content class="mat-typography">
            <div class="content-container">
                <div class="servers-conteiner">
                    <div class="title">Orderbook Servers</div>
                    <div
                        class="server"
                        *ngFor="let s of orderbookServers"
                        (click)="selectOrderbookServer(s)"
                        [ngStyle]="{ 'cursor': isOrderbookConnected ? 'unset' : 'pointer' }"
                    >
                        <div
                            class="is-selected"
                            [ngStyle]="{'visibility' : selectedOrderbookServer === s ? 'visible' : 'hidden'}"
                        ><p [ngStyle]="{'background-color': isOrderbookConnected ? 'green' : 'red'}"></p></div>
                        <div *ngIf="s !== '@custom'" class="url"> {{ s }} </div>
                        <input
                            #input
                            *ngIf="s === '@custom'"
                            type="text"
                            class="input_url"
                            [disabled]="selectedOrderbookServer !== '@custom'"
                            placeholder="Custom Url"
                            [(ngModel)]="customOrderbookUrl"
                        >
                        <div
                            class="buttons"
                            [ngStyle]="{'visibility' : selectedOrderbookServer === s ? 'visible' : 'hidden'}"
                        >
                            <button
                                *ngIf="isOrderbookConnected"
                                class='redButton'
                                mat-button
                                (click)="disconnectOrderbookServer()"
                            > disconnect </button>
                            <button
                                *ngIf="!isOrderbookConnected"
                                class='greenButton'
                                mat-button
                                (click)="connectOrderbookServer()"
                            > Connect </button>
                        </div>
                    </div>
                </div>

                <!-- <div class="servers-conteiner">
                    <div class="title">API Servers</div>
                    <div
                        class="server"
                        *ngFor="let s of apiServers"
                        (click)="selectApiServer(s)"
                        [ngStyle]="{ 'cursor': isApiConnected ? 'unset' : 'pointer' }"
                    >
                        <div
                            class="is-selected"
                            [ngStyle]="{'visibility' : selectedApiServer === s ? 'visible' : 'hidden'}"
                        ><p [ngStyle]="{'background-color': isApiConnected ? 'green' : 'red'}"></p></div>
                        <div *ngIf="s !== '@custom'" class="url"> {{ s }} </div>
                        <input
                            *ngIf="s === '@custom'"
                            type="text"
                            class="input_url"
                            [disabled]="selectedApiServer !== '@custom'"
                            placeholder="Custom Url"
                            [(ngModel)]="customApiUrl"
                        >
                        <div
                            class="buttons"
                            [ngStyle]="{'visibility' : selectedApiServer === s ? 'visible' : 'hidden'}"
                        >
                            <button
                                *ngIf="isApiConnected"
                                class='redButton'
                                mat-button
                                (click)="disconnectApiServer()"
                            > disconnect </button>
                            <button
                                *ngIf="!isApiConnected"
                                class='greenButton'
                                mat-button
                                (click)="connectApiServer()"
                            > Connect </button>
                        </div>
                    </div>
                </div> -->

                <div class="servers-conteiner">
                    <div class="title">Collator Manifest (TL-CSv1)</div>
                    <div class="server" style="cursor: default;">
                        <div class="is-selected" style="visibility: visible;">
                            <p [ngStyle]="{'background-color': collatorManifest?.verified ? 'green' : 'red'}"></p>
                        </div>
                        <input
                            type="text"
                            class="input_url"
                            placeholder="ws://127.0.0.1:8787/ws"
                            [(ngModel)]="collatorWsUrl"
                        >
                        <div class="buttons" style="visibility: visible;">
                            <button class="greenButton" mat-button (click)="fetchCollatorManifest()">Fetch</button>
                        </div>
                    </div>
                    <div *ngIf="collatorManifest" style="font-size: 12px; opacity: 0.9; padding: 6px 0;">
                        <div>manifestUrl: {{ collatorManifest.manifestUrl }}</div>
                        <div>verified: {{ collatorManifest.verified ? 'yes' : 'no' }} <span *ngIf="!collatorManifest.verified">({{ collatorManifest.reason }})</span></div>
                        <div *ngIf="collatorManifest.manifest">
                            <div>collatorId: {{ collatorManifest.manifest.collatorId }}</div>
                            <div>build: {{ collatorManifest.manifest.build?.version || '-' }} {{ collatorManifest.manifest.build?.gitSha || '' }}</div>
                            <div>policy.network: ipLogging={{ collatorManifest.manifest.policy?.network?.ipLogging || '-' }}, vpn={{ collatorManifest.manifest.policy?.network?.vpnFilterMode || '-' }}, asn={{ collatorManifest.manifest.policy?.network?.asnBlockMode || '-' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-dialog-content>
    </div>
</custom-window>
